export default __webpack_public_path__ + "static/media/hand_left.2266f228.png";